import { useEffect, useRef, useState, } from 'react';
import { useGLTF } from '@react-three/drei';
import WellModel from '../../../assets/well/Well.glb';

const Well = (props) => {
  const { tossCoin } = props;
	let modelPrimitive = useGLTF(WellModel);
	const [ modelClone, setModelClone] = useState();
	const modelMesh = useRef();
	
	useEffect(() => {
		if (modelPrimitive?.scene) {
			const modelClone = modelPrimitive?.scene?.clone();
			setModelClone(modelClone);
		}
	}, [modelPrimitive?.scene]);

	if (!modelClone?.uuid) {
		return null;
	}

  return (
		<mesh
			ref={modelMesh}
			position={[0, -2, -0.06]}
			onClick={tossCoin}
			onTouchStart={tossCoin}
			castShadow
			receiveShadow
		>
      <primitive object={modelClone} key={modelClone?.uuid} />
    </mesh>
  )
}

export default Well;